import React from 'react'

function Hero() {
  return (
    <section className="hero">
    <div className="container">
        <h1 className="text-center">
            Sosiaalinen kasino Crazy Monkey Slot tarjoaa ainutlaatuisen mahdollisuuden kokea kolikkopelien jännitystä
        </h1>
        <div className="inner-wrapper d-flex align-items-center justify-content-between mb-5">
            <div className="left-col">
                <img src="/1_(2).jpg" alt="Crazy Monkey Slot Hero Image"/>
            </div>
            <div className="right-col">
                <p className="hero-text text">
                    Tämä ilmainen viihde vie sinut kiehtovaan sosiaalisen pelaamisen maailmaan, jossa voit nauttia kasinomaailman jännityksestä mukavasti kotonasi. Sekä mobiililaitteille että tietokoneille suunniteltu peli on saatavilla iOS- ja Android-laitteilla, joten voit pelata missä ja milloin tahansa.
                </p>
            </div>
        </div>
        <p className="hero-text text text-md">
            Ensimmäisestä hetkestä alkaen sinut imaisee pelin juhlatunnelma. Kirkkaat värit ja mukaansatempaavat ääniefektit luovat upean visuaalisen ja auditiivisen elämyksen. Pelin symbolit, kuten kultakolikot, hohtavat lyhdyt ja mehukkaat hedelmät, tekevät jokaisesta kierroksesta jännittävän. Crazy Monkey Slot tarjoaa unohtumattoman elämyksen ja kutsuu jokaisen pelaajan osaksi sosiaalista yhteisöämme.
        </p>
    </div>
</section>

  )
}

export default Hero